import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  padding: ${({ $padding }) => $padding ?? '30px 24px'};
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
  gap: 20px;
  background-color: #f8f9fa;
`;

export const Card = styled.div`
  width: calc(33% - 40px);
  height: 217px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.common.white};
  transition: 0.4s ease-in-out all;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;

  &.reportings {
    .icon {
      background: #0177fb1a;

      svg path {
        fill: #0177fb;
      }
    }
  }

  &.extractions {
    .icon {
      background: #f5c72533;

      svg path {
        fill: #f5c725;
      }
    }
  }

  &.analytics {
    .icon {
      background: #3fea9c33;

      svg path {
        fill: #3fea9c;
      }
    }
  }

  &:hover {
    box-shadow:
      0px 12px 27px 0px #0000000d,
      0px 49px 49px 0px #0000000a,
      0px 111px 66px 0px #00000008,
      0px 197px 79px 0px #00000003,
      0px 307px 86px 0px #00000000;
  }

  .icon {
    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.background.default};
  }

  .content {
    h2 {
      font-size: 18px;
      font-weight: 600;
      line-height: 22px;
    }

    p {
      margin-top: 19px;
      font-size: 14px;
      font-weight: 300;
      line-height: 22px;
    }
  }
`;

export const Box = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  h1 {
    font-size: 24px;
    font-weight: 400;
    line-height: 29px;
    letter-spacing: 0em;
    text-align: left;
  }

  p {
    margin-top: 31px;

    font-size: 18px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
  }

  .uploads {
    margin-top: 19px;
    width: 100%;
    display: flex;
    gap: 24px;

    .item {
      width: 50%;
    }
  }
`;

export const IntegrationsBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const IntegrationsList = styled.ul`
  margin: 0;
  padding: 0;
  width: 100%;
`;

export const Integration = styled.li`
  width: 100%;
  margin: 15px auto 0 auto;
  padding: 0px 2px;
  display: flex;
  align-items: center;
  height: 40px;
  width: 160px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.background.default};
  gap: 5px;
  cursor: pointer;
  position: relative;

  img {
    z-index: 1;
    width: 20px;
    height: 20px;
    margin-left: 9px;
    margin-right: 9px;
  }

  span {
    position: absolute;
    z-index: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    border-radius: 18px;
    background-color: #fff;
    transition: 0.4s ease-in-out all;
  }

  &:hover {
    span {
      width: calc(100% - 4px);
    }
  }

  svg {
    z-index: 1;
    width: 36px;
  }

  p {
    z-index: 1;

    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: left;
    color: ${({ theme }) => theme.colors.tab.main};
  }
`;
